// extracted by mini-css-extract-plugin
export default {"nested":"AccordionGroup_nested__qiSpU"};